export default {"src":"/_next/static/media/APPLE.ae506685.svg","height":16,"width":14,"blurWidth":0,"blurHeight":0};